// PaymentMethods.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { PaymentOption } from './PaymentOption';
import { getCheckoutPrices, getPaymentOptions } from '../../api/requests/payment';
import { CheckoutPricesResponse, PaymentMethodOption } from '../../api/requests/interfaces/Payment';
import { Label } from '../form/Label';
import Dropdown, { DropdownOptionItem } from '../form/Dropdown';
import { DropdownSelectOption } from '../../constants/common';
import { ProductCategory } from '../../constants/products';
import { ProductCheckoutModel } from '../../api/requests/interfaces/Product';
import { SpinnerContainer } from '../common/SpinnerContainer';
import { Input } from '../form/Input';
import { PrimaryButton } from '../buttons/PrimaryButton';

interface PaymentFormProps {
    checkoutData?: ProductCheckoutModel,
    paymentOptionChanged: (code: string) => void,
    campaign1000: boolean,
    discountCodeApplied: (val: {code: string; discountCodeId: number} | undefined) => void,
    setCheckoutPricesResponse: (arg: CheckoutPricesResponse) => void
}

const PaymentForm: React.FC<PaymentFormProps> = (props) => {

    const [checkoutData, setCheckoutData] = useState<ProductCheckoutModel>(props.checkoutData || {});

    const [paymentMethods, setPaymentMethods] = useState<PaymentMethodOption[]>([]);
    const [paymentMethod, setPaymentMethod] = useState<string | undefined>(undefined);

    const [error, setError] = useState<string | undefined>();
    const [paymentUrl, setPaymentUrl] = useState<string | null>(null);

    const [checkoutOverviewData, setCheckoutOverviewData] = useState<CheckoutPricesResponse | undefined>(undefined);

    const [loadingPrices, setLoadingPrices] = useState<boolean>(true);

    const [totalPriceNothing, setTotalPriceNothing] = useState<boolean>(false);

    const [discountCode, setDiscountCode] = useState<string>("");


    const handleCreateOrder = async () => {

        try {
            // 1. Call the backend to create the order
            const response = await axios.post('http://localhost:5000/create-order', {
                name: "lol",
                description: "lol2"
            });

            // 2. Get the payment URL from the response
            const { paymentUrl } = response.data;
            console.log(JSON.stringify(response));
            console.log("paymentURL: " + paymentUrl);
            setPaymentUrl(paymentUrl);

            // 3. Redirect the customer to the payment URL
            /* if (paymentUrl) {
                window.location.href = paymentUrl; // Redirect to payment gateway
            } */
        } catch (err) {
            console.error('ERROR creating order:', err);
            setError('Failed to create payment order');
        }
    };

    /* useEffect(() => {
        console.log(paymentMethod);
    }, [paymentMethod]) */

    const handlePaymentOptionChanged = (code: string) => {
        props.paymentOptionChanged(code);
        setPaymentMethod(code);
    }

     useEffect(() => {
        const fetchPaymentMethods = async () => {
            try {
                const response = await getPaymentOptions();
                setPaymentMethods(response);
            } catch (err) {
                console.error('Error fetching payment methods:', err);
            }
        };
        fetchPaymentMethods();
    }, []);

    useEffect(() => {
        // If props.checkoutData is present, update checkoutData with the new values
        if (props.checkoutData) {
            console.log("BOOST OPTION ", props.checkoutData.boostLevel);
            setCheckoutData(prevData => ({
                ...props.checkoutData,  // Use the latest props.checkoutData
                discountCode: discountCode.length ? discountCode : undefined // Ensure the discountCode is also passed through
            }));
        }
    }, [props.checkoutData]);
 /*
    useEffect(() => {
        // If campaign is active, total price is automatically 0
        if (props.campaign1000 && checkoutOverviewData) {
            setCheckoutOverviewData(prevData => ({
                ...checkoutOverviewData,
                total: 0
            }));
        }
    }, [checkoutOverviewData]);*/

    useEffect(() => {
        const fetchCheckoutPrices = async () => {
            if (checkoutData) {
                setLoadingPrices(true);
                try {
                    checkoutData.campaign1000 = props.campaign1000;
                    // console.log("CAMPAIGN1000: " + props.campaign1000);
                    const response = await getCheckoutPrices(checkoutData);
                    setCheckoutOverviewData(response);
                    props.setCheckoutPricesResponse(response); // To send to ItemEditPage
                    if (response.discountCodeAmount && response.discountCodeAmount > 0 && props.checkoutData?.discountCode !== checkoutData.discountCode) {
                        props.discountCodeApplied({code: checkoutData.discountCode!, discountCodeId: checkoutData.discountCodeId!});
                    } else if (props.checkoutData?.discountCode !== checkoutData.discountCode) {
                        props.discountCodeApplied(undefined);
                    }
                } catch (err) {
                    console.error('Error fetching prices:', err);
                }
                setLoadingPrices(false);
            }

        };
        fetchCheckoutPrices();
    }, [checkoutData, props.campaign1000])

    if (error) return <div>{error}</div>;

    return (
        <div>
            <h3 className='mb-1'>Tellimuse ülevaade</h3>

            {/* {JSON.stringify(paymentMethods, null, 2)} */}
            {/* {JSON.stringify(paymentMethods.paymentInitiation.setup.EE.paymentMethods)} */}
            <div className={`${!checkoutOverviewData?.total && !checkoutOverviewData?.priceAmount ? "pointer-events-none opacity-25" : ""} ml-2 lg:ml-2 py-2 lg:max-w-[360px]`}>

                    <div className='flex flex-col gap-1 w-[230px] text-[15px] font-light'>

                        {/* {props.campaign1000 ?
                            <div className='flex flex-row justify-between text-green-700 pb-1'>
                                <div className='leading-[18px]'>Kampaania: piiratud koguses kuulutusi esimene kuu tasuta</div>
                                <div className='min-w-[60px] text-right pl-2'>TASUTA</div>
                            </div> : null
                        } */}
                        {checkoutOverviewData?.discountAmount !== 0 &&

                            <div className='flex flex-row justify-between text-green-700 pb-1'>
                                <div className='leading-[20px]'>{checkoutOverviewData?.discountText}</div>
                                <div className='min-w-[60px] text-right'>-{checkoutOverviewData?.discountAmount} €</div>
                            </div>
                        }
                        {checkoutOverviewData?.discount2Amount !== 0 &&
                            <div className='flex flex-row justify-between text-green-700 pb-1'>
                                <div className='leading-[20px]'>{checkoutOverviewData?.discount2Text}</div>
                                <div className='min-w-[60px] text-right'>-{checkoutOverviewData?.discount2Amount} €</div>
                            </div>
                        }
                        {checkoutOverviewData?.discountCodeAmount !== 0 &&
                            <div className='flex flex-row justify-between text-green-700 pb-1'>
                                <div className='leading-[20px]'>{checkoutOverviewData?.discountCodeText}</div>
                                <div className='min-w-[60px] text-right'>-{checkoutOverviewData?.discountCodeAmount} €</div>
                            </div>
                        }
                        {checkoutOverviewData?.priceBoost !== 0 &&
                            <div className='flex flex-row justify-between'>
                                <div>{checkoutOverviewData?.textBoost}</div>
                                <div className=''>{checkoutOverviewData?.priceBoost} €</div>
                            </div>
                        }
                        <div className='flex flex-row justify-between'>
                            <div>Summa</div>
                            <div className=''>{checkoutOverviewData?.priceAmount} €</div>
                        </div>
                        <div className='flex flex-row justify-between'>
                            <div className='font-semibold'>Kokku tasuda</div>
                            <div className='font-semibold'>{checkoutOverviewData?.total} €</div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex flex-row justify-between mt-2">
                                <div className="flex w-[120px]">
                                    <Input value={discountCode} onChange={(e) => setDiscountCode(e)} placeHolder="Sooduskood" name="promocode" invalid={checkoutOverviewData?.discountCodeStatus === "error"}
                                        errorText={checkoutOverviewData?.discountCodeResponse}></Input>

                                </div>
                                <div className="flex w-[80px]">
                                    <PrimaryButton title={'Rakenda'} onClick={() => {
                                        setCheckoutData(prevData => ({
                                            ...prevData,
                                            discountCode: discountCode.length ? discountCode : undefined
                                        }));
                                    }}></PrimaryButton>
                                </div>

                            </div>
                            <div>
                                {checkoutOverviewData?.discountCodeStatus === "success" &&
                                    <div className='text-green-600'>
                                        {checkoutOverviewData.discountCodeResponse}
                                    </div>
                                }
                            </div>
                            <div className="flex flex-row text-sm text-gray-600 mt-2"><div className="text-primary">*</div>Iga tehingu (va 100% soodust) miinimumhinnaks on alati 0.50€</div>

                        </div>

                    </div>
                </div>
                <div className='pb-3'><Label value={"Vali allolevate maksemeetodite vahel"} /></div>
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-2 py-4 w-full rounded-xl shadow-main p-1 lg:p-6">
            {/* <div className="relative grid grid-cols-2 lg:grid-cols-3 gap-4 max-w-[500px]"> */}
            {/* {checkoutOverviewData?.total === 0 &&
                    <div className="absolute flex items-center justify-center bg-white/80 h-full w-full z-60">
                        <h1 className='text-green-600 rotate-12'>Makse jääk on 0!</h1>
                    </div>
                } */}

            {paymentMethods?.map((method, index: any) => (
                    <PaymentOption key={index} logo={method.logoUrl} option={method.code} text={method.name} paymentMethod={paymentMethod} setPaymentMethod={(v) => handlePaymentOptionChanged(v)} />
                ))}
            {/* {/* </div> */}
            <PaymentOption key={paymentMethods.length + 1} option={"CARD"} text={"Kaardimakse"} paymentMethod={paymentMethod} setPaymentMethod={(v) => handlePaymentOptionChanged(v)} />
            </div>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {paymentUrl && <p>Redirecting to payment: <a href={paymentUrl}>{paymentUrl}</a></p>}


        </div >
    );
};

export default PaymentForm;
